import React, {useEffect, useState} from "react";
import useAuth from "../../../../hooks/useAuth";
import Dialog from "@mui/material/Dialog";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import {tasksApi} from "../../../../services/User/calendar";
import ShowTask from "./ShowTask";

export default function CalendarWorker(){
    const { auth } = useAuth()
    const idUser = auth ? auth.primaryUser.idUser : null

    const [tasks, setTasks] = useState([])
    const [idTask, setIdTask] = useState(null)
    const [dateTask, setDateTask] = useState([])
    const { logout } = useAuth()

    const [open, setOpen] = React.useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        getTask()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getTask = async () =>{
        
        tasksApi({
            idWorker: idUser
        }).then(response => {
            if (response.status) {
                const temp = response.data.data.map((doc) => {
                    return {
                        ...doc,
                        id: doc.id,
                        color: `#${doc.idWorker.color}`,
                        title: `${doc.idClient.name} ${doc.idClient.surnames}`,
                        date: doc.startHour *1000,
                        start: doc.startHour *1000,
                        end: doc.endHour *1000,
                    }
                });
                setTasks(temp);
            }
          
        }).catch(error => {
            console.error(error)
        })
    }

    const clickTask = (arg) => {
        setIdTask(arg.event.id)
        setDateTask(null)
        setOpen(true)
    }

    if (!tasks) return ""

    return (
        <div className="col-lg-9">
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <h5 className="card-header-title">
                        Calendario
                    </h5>
                </div>

                <div className="card-body" style={{minHeight: "500px"}}>
                    <Dialog fullScreen open={open} onClose={handleClose}>
                        <ShowTask handleClose={handleClose} idTask={idTask} dateTask={dateTask} />
                    </Dialog>

                    <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                        initialView="timeGridDay"
                        locale="es"
                        allDayText="Horas"
                        headerToolbar={{
                            right: 'timeGridDay,listMonth',
                            left: 'prev,next',
                            center: ''
                        }}
                        height="490px"
                        nowIndicator="true"

                        buttonIcons={false} // show the prev/next text
                        navLinks={true} // can click day/week names to navigate views
                        editable={true}

                        buttonText = {{
                            today:   'Hoy',
                            month:   'Mes',
                            week:    'Semana',
                            day:     'Día',
                            list:    'Lista',
                            prev:    '<',
                            next:    '>'
                        }}

                        displayEventTime ={true}
                        displayEventEnd = {true}

                        eventTimeFormat={{ // like '14:30:00'
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }}

                        eventClick={(clickInfo) => {
                            clickTask(clickInfo);
                        }}

                        events={tasks}
                    />

                </div>
            </div>
        </div>
    )
}